import styled from 'styled-components/macro';

import { colors, distances } from '../styles/constants';

const H1 = styled.h1`
    color: ${colors.primary};
    font-size: 30px;
    font-weight: 700;
    line-height: 48px;
    margin: 0;
`;

const H2 = styled.h2`
    font-size: 23px;
    font-weight: 700;
    line-height: ${distances.normal};
    margin: 0;
`;

const H2Alt = styled.h2`
    color: #d8d8d8;
    font-size: 14px;
    font-weight: 700;
    line-height: ${distances.normal};
    text-transform: uppercase;
    margin: 0;
`;

const H3 = styled.h2`
    font-size: 14px;
    font-weight: 700;
    line-height: ${distances.normal};
    margin: 0;
`;

const H4 = styled.h2`
    font-size: 12px;
    font-weight: normal;
    line-height: ${distances.normal};
    margin: 0;
    text-transform: uppercase;
`;

const H4Label = styled.h4`
    padding: ${distances.tiny} 0;
    font-weight: 700;
    display: block;
`;

const Label = styled.label`
    padding: ${distances.tiny} 0;
    font-weight: 700;
    display: block;
`;

const Text = styled.span`
    color: ${colors.text};
    font-size: 14px;
    line-height: 22px;
`;

const P = styled.p`
    color: ${colors.text};
    font-size: 14px;
    line-height: 22px;
    margin: 0;

    &.margin-bottom {
        margin-bottom: ${distances.small};
    }

    &.margin-top {
        margin-top: ${distances.small};
    }
`;

const Muted = styled.em`
    color: ${colors.borderDark};
    font-size: 14px;
    line-height: ${distances.small};
`;
const Small = styled.small`
    color: ${colors.text};
    font-size: 11px;
    line-height: ${distances.small};
`;

export { H1, H2, H2Alt, H3, H4, Text, P, Muted, Small, H4Label, Label };
